import { post } from './http';
import { triggerToast } from './Toast.service';
import { translate } from './translation';
export const WISHLIST_CHANGE_QUANTITY = 'WISHLIST_CHANGE_QUANTITY';
export const WISHLIST_UPDATE = 'WISHLIST_UPDATE';
export const WISHLIST_ADD_TO_CART = 'WISHLIST_ADD_TO_CART';

const triggerErrorToast = (message) => {
    triggerToast({
      title: translate('general.error'),
      text: message,
      type: 'error',
      autoClose: false,
    });
  };
 
export const add = (id, quantity = 1) => {
    return async (dispatch) => {
        try {
            const response = await post('/api/wishlist/add', {
                id,
                quantity: 1,
            });

            const data = await response.json();
            dispatch({
                type: WISHLIST_UPDATE,
                payload: {
                    success: true,
                    message: translate('wishlist.message-success'),
                },
                id: id,
                items: data
            });
        } catch (error) {
            triggerErrorToast(error?.error ?? translate('general.error'));
        }
    };
};

export const addMultiple = (items) => {
    return async (dispatch) => {
        try {
            const response = await post('/api/wishlist/addMultiple', items);

            const data = await response.json();

            dispatch({
                type: WISHLIST_UPDATE,
                payload: {
                    success: true,
                    message: translate('wishlist.message-success'),
                },
                items: data
            });
            
            if(response.ok){
                triggerToast({
                    text: translate('checkout.favorites.success'),
                    type: 'success',
                });
            }
        } catch (error) {
            triggerErrorToast(error?.error ?? translate('general.error'));
        }
    };
};
 
export const updateWishList = () => (dispatch, getState) => {
    return post('/api/wishlist/update', getState().wishList)
        .then((response) => response.json())
        .then((result) => {
            dispatch({
                type: WISHLIST_UPDATE,
                payload: {
                    success: true,
                    message: translate('wishlist.message-success'),
                },
            });
        })
        .catch((ex) => {
            dispatch({
                type: WISHLIST_UPDATE,
                payload: {
                    success: false,
                    message: translate('wishlist.message-error'),
                },
            });
        });
};

export const remove = (id, quantity = 1) => {
    return async (dispatch) => {
        try {
            const response = await post('/api/wishlist/remove', {
                id,
                quantity: 1,
            });
            const data = await response.json()          
            dispatch({
                type: WISHLIST_UPDATE,
                payload: {
                    success: true,
                    message: translate('wishlist.message-success'),
                },
                id: id,
                items: data
            });       
        }   
        catch (error) {
            triggerErrorToast(error?.error ?? translate('general.error'));
        }
    };
};
 
export const addToCart = () => (dispatch) => {
    return post('/api/wishlist/addtocart')
        .then((response) => response.json())
        .then((result) => {
            dispatch({
                type: WISHLIST_ADD_TO_CART,
                payload: {
                    success: true,
                    message: translate('wishlist.item-added-success'),
                },
            });
        })
        .catch((ex) => {
            dispatch({
                type: WISHLIST_ADD_TO_CART,
                payload: {
                    success: false,
                    message: translate('wishlist.message-error'),
                },
            });
        });
};